export default {
    showing: "Showing {0}-{1} of {2}",
    items_per_page: "Items per page:",
    go_to: "Go to:",
};
